import type { User } from 'src/api/organization';
import type { ActivityDTO } from 'src/types/dto';

export type BusinessUnitRef = {
  id: number;
  name: string;
};

export function getProjectOwnerFromActivity(activity: ActivityDTO): User | undefined {
  return activity.standard?.project?.owner;
}

/** Mirrors backend mergeUserBusinessUnits: manager join rows first, then inspector BU. */
export function getProjectOwnerBusinessUnits(owner: User | null | undefined): BusinessUnitRef[] {
  if (!owner) {
    return [];
  }

  const fromJoin = (owner.businessUnits ?? []).map((bu) => ({
    id: bu.id,
    name: bu.name,
  }));
  const inspectorBu = owner.inspector?.businessUnit;

  if (!inspectorBu) {
    return fromJoin;
  }

  if (fromJoin.some((bu) => bu.id === inspectorBu.id)) {
    return fromJoin;
  }

  return [...fromJoin, { id: inspectorBu.id, name: inspectorBu.name }];
}

export function getProjectOwnerPrimaryBusinessUnit(
  owner: User | null | undefined
): BusinessUnitRef | null {
  return getProjectOwnerBusinessUnits(owner)[0] ?? null;
}

export function collectBusinessUnitFilterFromActivities(activities: ActivityDTO[]): {
  businessUnitIds: number[];
  businessUnitLabels: Record<string, string>;
} {
  const byId = new Map<number, string>();

  activities.forEach((activity) => {
    getProjectOwnerBusinessUnits(getProjectOwnerFromActivity(activity)).forEach((businessUnit) => {
      byId.set(businessUnit.id, businessUnit.name);
    });
  });

  const businessUnitIds = Array.from(byId.keys());
  const businessUnitLabels = Object.fromEntries(
    businessUnitIds.map((id) => [String(id), byId.get(id)!])
  );

  return { businessUnitIds, businessUnitLabels };
}
